import AutomacaoPaleta from './AutomacaoPaleta.vue'
import AutomacaoCanvas from './AutomacaoCanvas.vue'
import AutomacaoSidebar from './AutomacaoSidebar.vue'
import AutomacaoWizard from './AutomacaoWizard.vue'
import { gerarAutomacaoIa, salvarAutomacao } from './automacao-editor-api'
import {
  adicionarNo,
  adicionarNoFilho,
  atualizarDadosNo,
  atualizarRotulosCanvas,
  carregarCanvas,
  criarEditor,
  exportarCanvas,
  importarCanvas,
  layoutAutomatico,
  listarOportunidadesDoFluxo,
  marcarErrosNos,
  posicaoDrop,
  removerRamoDoFluxo,
} from './automacao-drawflow'

export default {
  name: 'AutomacaoEditorApp',
  components: {
    AutomacaoPaleta,
    AutomacaoCanvas,
    AutomacaoSidebar,
    AutomacaoWizard,
  },
  props: {
    automacao: {
      type: Object,
      default: function () {
        return { id: null, nome: '', ativo: true, canvas: null, modo: 'fluxo' }
      },
    },
    pipelines: {
      type: Array,
      default: function () {
        return []
      },
    },
    fasesPorPipeline: {
      type: Object,
      default: function () {
        return {}
      },
    },
    templates: {
      type: Array,
      default: function () {
        return []
      },
    },
    conexoes: {
      type: Array,
      default: function () {
        return []
      },
    },
    usuariosPorPipeline: {
      type: Object,
      default: function () {
        return {}
      },
    },
    camposCustomizados: {
      type: Array,
      default: function () {
        return []
      },
    },
    status: {
      type: Array,
      default: function () {
        return []
      },
    },
    saveUrl: {
      type: String,
      required: true,
    },
    saveMethod: {
      type: String,
      default: 'post',
    },
    indexUrl: {
      type: String,
      required: true,
    },
    gerarUrl: {
      type: String,
      default: '',
    },
    abrirIa: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nome: this.automacao.nome || '',
      ativo: this.automacao.ativo !== false,
      modo: this.automacao.modo === 'wizard' ? 'wizard' : 'fluxo',
      editor: null,
      noSelecionado: null,
      dadosPorNo: {},
      oportunidadesDoFluxo: [{ id: 'atual', rotulo: 'A que disparou o fluxo' }],
      salvando: false,
      erro: '',
      erroNome: '',
      errosPorNo: {},
      errosGerais: [],
      revisaoGrafo: 0,
      snapshotInicial: '',
      mostrarAvisoSaida: false,
      destinoSaida: '',
      permitirSaida: false,
      mostrarCompositorIa: false,
      compositorSaindo: false,
      gerandoIa: false,
      pedidoIa: '',
      erroIa: '',
      avisoIa: [],
      fraseIa: 0,
      timerFraseIa: null,
      exemplosIa: [
        'Ao ganhar uma oportunidade, se a pipeline for Desenvolvimento IA cria uma tarefa de onboarding; senão avisa o gestor',
        'Quando um cliente é cadastrado, cria uma oportunidade e notifica o gestor',
        'Quando a oportunidade muda de fase, envia um e-mail ao cliente',
      ],
      frasesIa: [
        'A IA está lendo o pedido',
        'Escolhendo gatilho e condições',
        'Preenchendo os blocos',
        'Ligando os ramos do fluxo',
      ],
      canvasTemNos: false,
      quantidadeNos: 0,
      confirmandoSubstituicao: false,
    }
  },
  computed: {
    temFluxo() {
      return this.canvasTemNos
    },
    pedidoPronto() {
      return (this.pedidoIa || '').trim().length >= 10
    },
    rotuloGerarIa() {
      if (this.gerandoIa) {
        return 'Montando...'
      }
      return this.temFluxo ? 'Substituir fluxo' : 'Montar fluxo'
    },
    pendenciasIa() {
      return (this.avisoIa || []).join(' ')
    },
  },
  mounted() {
    const container = this.$refs.canvas.$refs.drawflow
    this.editor = criarEditor(container, this.selecionarNo)
    importarCanvas(this.editor, this.automacao.canvas, this.contextoRotulos())
    this.hidratarDadosNos()
    this.editor.on('nodeCreated', (id) => {
      this.capturarDadosNo(id)
      this.atualizarOportunidadesDoFluxo()
      this.atualizarCanvasTemNos()
    })
    this.editor.on('nodeRemoved', this.aoRemoverNo)
    this.atualizarRotulosEOportunidades()
    this.revisaoGrafo += 1
    this.snapshotInicial = this.snapshotAtual()
    document.addEventListener('click', this.aoClicarLink, true)
    document.addEventListener('keydown', this.aoTeclarIa)
    window.addEventListener('beforeunload', this.aoAntesDeSair)
    this.atualizarCanvasTemNos()
    if (this.abrirIa) {
      this.$nextTick(this.abrirCompositorIa)
    }
  },
  beforeDestroy() {
    this.pararFrasesIa()
    document.removeEventListener('click', this.aoClicarLink, true)
    document.removeEventListener('keydown', this.aoTeclarIa)
    window.removeEventListener('beforeunload', this.aoAntesDeSair)
    if (this.editor) {
      this.editor.clear()
    }
  },
  methods: {
    definirModo(modo) {
      if (this.modo === modo) {
        return
      }
      this.modo = modo
      if (modo === 'fluxo' && this.editor) {
        this.$nextTick(() => {
          layoutAutomatico(this.editor, this.contextoRotulos())
          this.atualizarRotulosEOportunidades()
        })
      }
    },
    selecionarNo(id, no) {
      if (!id || !no) {
        this.noSelecionado = null
        this.atualizarOportunidadesDoFluxo()
        return
      }
      const chave = String(id)
      if (!this.dadosPorNo[chave]) {
        this.$set(this.dadosPorNo, chave, Object.assign({}, no.data || {}))
      }
      this.noSelecionado = {
        id: id,
        data: Object.assign({}, this.dadosPorNo[chave]),
      }
      this.atualizarOportunidadesDoFluxo(id)
    },
    selecionarNoDoWizard(id) {
      if (!this.editor || !id) {
        this.selecionarNo(null, null)
        return
      }
      try {
        this.selecionarNo(id, this.editor.getNodeFromId(id))
      } catch (erro) {
        this.selecionarNo(null, null)
      }
    },
    adicionarDoWizard(payload) {
      if (!this.editor || !payload || !payload.tipo) {
        return
      }
      this.erro = ''
      const id = payload.paiId
        ? adicionarNoFilho(this.editor, payload.tipo, payload.paiId, payload.saida || 'output_1')
        : adicionarNo(this.editor, payload.tipo, 80, 80)
      if (!id) {
        this.erro = 'Não foi possível adicionar esse bloco.'
        return
      }
      this.revisaoGrafo += 1
      this.selecionarNoDoWizard(id)
      this.atualizarRotulosEOportunidades(id)
    },
    removerDoWizard(id) {
      if (!this.editor || !id) {
        return
      }
      removerRamoDoFluxo(this.editor, id)
      const dados = (((this.editor.export() || {}).drawflow || {}).Home || {}).data || {}
      if (this.noSelecionado && !dados[String(this.noSelecionado.id)]) {
        this.noSelecionado = null
      }
      this.revisaoGrafo += 1
      this.atualizarRotulosEOportunidades()
    },
    soltarBloco(event) {
      const tipo = event.dataTransfer.getData('node')
      if (!tipo || !this.editor) {
        return
      }
      const posicao = posicaoDrop(this.$refs.canvas.$refs.drawflow, event)
      adicionarNo(this.editor, tipo, posicao.x, posicao.y)
      this.revisaoGrafo += 1
      this.atualizarRotulosEOportunidades()
    },
    atualizarNo(id, data) {
      const payload = Object.assign({}, data)
      const chave = String(id)
      if (this.errosPorNo[chave]) {
        const restantes = Object.assign({}, this.errosPorNo)
        delete restantes[chave]
        this.errosPorNo = restantes
      }
      this.$set(this.dadosPorNo, chave, payload)
      this.noSelecionado = {
        id: id,
        data: Object.assign({}, payload),
      }
      atualizarDadosNo(this.editor, id, payload, this.contextoRotulos())
      this.atualizarRotulosEOportunidades(id)
    },
    hidratarDadosNos() {
      if (!this.editor) {
        return
      }
      const data = (((this.editor.export() || {}).drawflow || {}).Home || {}).data || {}
      Object.keys(data).forEach((id) => {
        this.$set(this.dadosPorNo, String(id), Object.assign({}, data[id].data || {}))
      })
    },
    capturarDadosNo(id) {
      if (!this.editor || !id) {
        return
      }
      const chave = String(id)
      if (this.dadosPorNo[chave]) {
        return
      }
      try {
        const no = this.editor.getNodeFromId(id)
        this.$set(this.dadosPorNo, chave, Object.assign({}, (no && no.data) || {}))
      } catch (erro) {
        this.$set(this.dadosPorNo, chave, {})
      }
    },
    aplicarDadosNosNoCanvas() {
      if (!this.editor) {
        return
      }
      Object.keys(this.dadosPorNo).forEach((id) => {
        atualizarDadosNo(this.editor, id, this.dadosPorNo[id], this.contextoRotulos())
      })
    },
    contextoRotulos() {
      return {
        pipelines: this.pipelines,
        fasesPorPipeline: this.fasesPorPipeline,
      }
    },
    atualizarRotulosEOportunidades(noAtualId) {
      atualizarRotulosCanvas(this.editor, this.contextoRotulos())
      this.atualizarOportunidadesDoFluxo(noAtualId)
      this.marcarErrosNoFluxo()
    },
    atualizarOportunidadesDoFluxo(noAtualId) {
      const id = noAtualId || (this.noSelecionado && this.noSelecionado.id)
      this.oportunidadesDoFluxo = listarOportunidadesDoFluxo(this.editor, id, this.contextoRotulos())
    },
    aoRemoverNo(idRemovido) {
      this.$delete(this.dadosPorNo, String(idRemovido))
      this.corrigirAlvosRemovidos(idRemovido)
      this.atualizarRotulosEOportunidades()
      this.atualizarCanvasTemNos()
    },
    corrigirAlvosRemovidos(idRemovido) {
      if (!this.editor) {
        return
      }
      const dados = (((this.editor.export() || {}).drawflow || {}).Home || {}).data || {}
      Object.keys(dados).forEach((id) => {
        const noData = dados[id].data || {}
        if (String(noData.alvo) !== String(idRemovido)) {
          return
        }
        const novo = Object.assign({}, noData, { alvo: 'atual' })
        this.$set(this.dadosPorNo, String(id), novo)
        atualizarDadosNo(this.editor, id, novo, this.contextoRotulos())
        if (this.noSelecionado && String(this.noSelecionado.id) === String(id)) {
          this.noSelecionado = { id: id, data: novo }
        }
      })
    },
    snapshotAtual() {
      this.aplicarDadosNosNoCanvas()
      return JSON.stringify({
        nome: (this.nome || '').trim(),
        ativo: this.ativo,
        modo: this.modo,
        canvas: this.editor ? exportarCanvas(this.editor) : null,
      })
    },
    temAlteracaoNaoSalva() {
      if (!this.snapshotInicial) {
        return false
      }
      return this.snapshotAtual() !== this.snapshotInicial
    },
    aoClicarLink(event) {
      if (this.permitirSaida) {
        return
      }
      const alvo = event.target.nodeType === 1 ? event.target : event.target.parentElement
      if (!alvo || typeof alvo.closest !== 'function') {
        return
      }
      const link = alvo.closest('a[href]')
      if (!link) {
        return
      }
      if (this.$refs.avisoSaida && this.$refs.avisoSaida.contains(event.target)) {
        return
      }
      if (event.defaultPrevented || event.button !== 0) {
        return
      }
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
        return
      }
      if (link.target && link.target !== '_self') {
        return
      }
      const href = link.getAttribute('href')
      if (!href || href.charAt(0) === '#' || href.trim().toLowerCase().indexOf('javascript:') === 0) {
        return
      }
      if (!this.temAlteracaoNaoSalva()) {
        return
      }
      event.preventDefault()
      event.stopPropagation()
      const overlayer = document.getElementById('overlayer-loading')
      if (overlayer) {
        overlayer.classList.remove('show-overlayer')
      }
      this.destinoSaida = link.href
      this.mostrarAvisoSaida = true
    },
    aoAntesDeSair(event) {
      if (this.permitirSaida || !this.temAlteracaoNaoSalva()) {
        return
      }
      event.preventDefault()
      event.returnValue = ''
    },
    fecharAvisoSaida() {
      this.mostrarAvisoSaida = false
      this.destinoSaida = ''
    },
    descartarAlteracoesESair() {
      if (!this.destinoSaida) {
        this.fecharAvisoSaida()
        return
      }
      this.permitirSaida = true
      window.location = this.destinoSaida
    },
    confirmarSaidaSalvando() {
      const destino = this.destinoSaida
      this.mostrarAvisoSaida = false
      this.salvar(destino)
    },
    definirErros(lista) {
      const porNo = {}
      const gerais = []
      ;(lista || []).forEach(function (item) {
        if (typeof item === 'string') {
          gerais.push(item)
          return
        }
        if (!item || !item.mensagem) {
          return
        }
        if (!item.id) {
          gerais.push(item.mensagem)
          return
        }
        const id = String(item.id)
        if (!porNo[id]) {
          porNo[id] = []
        }
        porNo[id].push(item.mensagem)
      })
      this.errosPorNo = porNo
      this.errosGerais = gerais
      this.marcarErrosNoFluxo()
      const primeiro = Object.keys(porNo)[0]
      if (primeiro) {
        this.selecionarNoDoWizard(primeiro)
      }
      this.$nextTick(this.mostrarPrimeiroErro)
    },
    marcarErrosNoFluxo() {
      marcarErrosNos(this.editor, this.errosPorNo)
    },
    mostrarPrimeiroErro() {
      const card = this.$el.querySelector('.automacao-wizard__card.is-invalido, .drawflow-node.is-invalido')
      if (card && card.scrollIntoView) {
        card.scrollIntoView({ block: 'nearest' })
      }
    },
    atualizarCanvasTemNos() {
      if (!this.editor) {
        this.canvasTemNos = false
        return
      }
      const data = (((this.editor.export() || {}).drawflow || {}).Home || {}).data || {}
      this.quantidadeNos = Object.keys(data).length
      this.canvasTemNos = this.quantidadeNos > 0
    },
    abrirCompositorIa() {
      this.definirModo('fluxo')
      this.atualizarCanvasTemNos()
      this.confirmandoSubstituicao = false
      this.compositorSaindo = false
      this.erroIa = ''
      this.mostrarCompositorIa = true
      this.$nextTick(() => {
        if (this.$refs.pedidoIa) {
          this.$refs.pedidoIa.focus()
        }
      })
    },
    fecharCompositorSeLivre() {
      if (this.gerandoIa) {
        return
      }
      this.fecharCompositorIa()
    },
    fecharCompositorIa() {
      if (this.gerandoIa) {
        return
      }
      this.compositorSaindo = true
      const reduzir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      window.setTimeout(() => {
        this.mostrarCompositorIa = false
        this.compositorSaindo = false
      }, reduzir ? 0 : 180)
    },
    aoTeclarIa(event) {
      if (event.key !== 'Escape' || !this.mostrarCompositorIa || this.gerandoIa) {
        return
      }
      if (this.confirmandoSubstituicao) {
        this.confirmandoSubstituicao = false
        return
      }
      this.fecharCompositorIa()
    },
    aoTeclarPedidoIa(event) {
      if (event.key !== 'Enter' || (!event.ctrlKey && !event.metaKey)) {
        return
      }
      event.preventDefault()
      this.gerarFluxoIa()
    },
    iniciarFrasesIa() {
      this.fraseIa = 0
      this.pararFrasesIa()
      this.timerFraseIa = window.setInterval(() => {
        this.fraseIa = (this.fraseIa + 1) % this.frasesIa.length
      }, 1600)
    },
    pararFrasesIa() {
      if (!this.timerFraseIa) {
        return
      }
      window.clearInterval(this.timerFraseIa)
      this.timerFraseIa = null
    },
    gerarFluxoIa() {
      if (this.gerandoIa || !this.pedidoPronto) {
        return
      }
      if (!this.gerarUrl) {
        this.erroIa = 'Não foi possível montar o fluxo. Recarregue a página.'
        return
      }
      this.atualizarCanvasTemNos()
      if (this.temFluxo && !this.confirmandoSubstituicao) {
        this.confirmandoSubstituicao = true
        this.$nextTick(() => {
          if (this.$refs.confirmarSubstituicao) {
            this.$refs.confirmarSubstituicao.focus()
          }
        })
        return
      }
      this.confirmandoSubstituicao = false
      this.erroIa = ''
      this.gerandoIa = true
      this.iniciarFrasesIa()
      const inicio = Date.now()
      gerarAutomacaoIa(this.gerarUrl, this.pedidoIa.trim())
        .then((resposta) => {
          const esperar = Math.max(0, 1800 - (Date.now() - inicio))
          return new Promise((resolve) => {
            window.setTimeout(() => resolve(resposta), esperar)
          })
        })
        .then((resposta) => {
          this.aplicarFluxoIa((resposta && resposta.data) || {})
        })
        .catch((erro) => {
          const dados = (erro.response && erro.response.data) || {}
          if (erro.code === 'ECONNABORTED') {
            this.erroIa = 'A montagem demorou demais. Tente de novo.'
            return
          }
          if (erro.response && erro.response.status === 429) {
            this.erroIa = 'Aguarde um instante para gerar de novo.'
            return
          }
          const pedido = dados.errors && dados.errors.pedido
          this.erroIa = (pedido && pedido[0]) || dados.message || 'Não foi possível montar o fluxo. Tente de novo com mais detalhes.'
        })
        .finally(() => {
          this.pararFrasesIa()
          this.gerandoIa = false
        })
    },
    aplicarFluxoIa(payload) {
      const canvas = payload.canvas
      const dados = canvas && canvas.drawflow && canvas.drawflow.Home && canvas.drawflow.Home.data
      if (!this.editor || !dados || !Object.keys(dados).length) {
        this.erroIa = 'Não foi possível montar o fluxo. Tente de novo com mais detalhes.'
        return
      }
      this.definirModo('fluxo')
      try {
        this.dadosPorNo = {}
        this.noSelecionado = null
        this.errosPorNo = {}
        this.errosGerais = []
        const quantidade = carregarCanvas(this.editor, canvas, this.contextoRotulos())
        this.hidratarDadosNos()
        this.atualizarRotulosEOportunidades()
        this.revisaoGrafo += 1
        this.atualizarCanvasTemNos()
        if (!quantidade) {
          this.erroIa = 'Não foi possível desenhar o fluxo. Tente de novo.'
          return
        }
        if (payload.nome) {
          this.nome = payload.nome
        }
        this.ativo = false
        this.avisoIa = Array.isArray(payload.avisos) ? payload.avisos.filter(Boolean) : []
        this.compositorSaindo = true
        const reduzir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
        window.setTimeout(() => {
          this.mostrarCompositorIa = false
          this.compositorSaindo = false
        }, reduzir ? 0 : 180)
      } catch (erro) {
        this.erroIa = 'Não foi possível desenhar o fluxo. Tente de novo.'
      }
    },
    salvar(destino) {
      this.erro = ''
      this.erroNome = ''
      this.definirErros([])
      if (!this.nome || this.nome.trim().length < 3) {
        this.erroNome = 'Informe o nome da automação.'
        return
      }

      const urlSaida = typeof destino === 'string' ? destino : ''
      this.salvando = true
      this.aplicarDadosNosNoCanvas()
      salvarAutomacao(this.saveUrl, this.saveMethod, {
        nome: this.nome.trim(),
        ativo: this.ativo,
        modo: this.modo,
        canvas: exportarCanvas(this.editor),
      })
        .then((resposta) => {
          this.permitirSaida = true
          if (urlSaida) {
            window.location = urlSaida
            return
          }
          if (resposta.data && resposta.data.redirect) {
            window.location = resposta.data.redirect
          }
        })
        .catch((erro) => {
          const dados = (erro.response && erro.response.data) || {}
          const lista = Array.isArray(dados.erros) ? dados.erros.filter(Boolean) : []
          if (lista.length) {
            this.definirErros(lista)
            return
          }
          this.definirErros([
            dados.message || 'Não foi possível salvar a automação.',
          ])
        })
        .finally(() => {
          this.salvando = false
        })
    },
  },
}
